const doc = [({"en":({"js":({"navigations":({"index":({"navigation":"Navigation"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;